module.exports = __webpack_public_path__ + "static/OpenOven03-f4ea9a2d9b9ceda8fd010cfa34a798d3.png";